import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=5ea985c4"
import script from "./user-card.ts?vue&type=script&lang=ts&external"
export * from "./user-card.ts?vue&type=script&lang=ts&external"
import style0 from "./user-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports